import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import MainMenuComponent from '../MainMenu';
import InteractivePopup from '../InteractivePopup';
import Icon from '../Icon';
import PageCaption from '../SiteHeader/page-caption';
import './styles.css';

class Nav extends React.PureComponent {
  static propTypes = {
    idPrefix: PropTypes.string,
    className: PropTypes.string,
    viewer: PropTypes.object,
  };

  static defaultProps = {
    idPrefix: 'main-nav',
  };

  state = { isOpen: false };

  handleOpen = () => {
    this.setState({ isOpen: true });
  };

  keyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      this.setState({ isOpen: true });
    }
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { idPrefix, viewer } = this.props;
    return (
      <InteractivePopup
        trigger={(
          /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
          <a
            data-cy="home-mainmenu-dropdown"
            name="mainmenu"
            role="link"
            styleName="headerText"
            tabIndex={0}
            onKeyDown={this.keyDown}
            onClick={this.handleOpen}
          >
            <PageCaption />
            <Icon name="sort" size="tiny" styleName="sortIcon" />
          </a>
        )}
        basic
        flowing
        hoverable
        wide="very"
        position="bottom left"
        styleName="menuPopup"
        open={this.state.isOpen}
        onClose={this.handleClose}
      >
        <MainMenuComponent idPrefix={idPrefix} onClick={this.handleClose} />
        {!viewer.isNaviance && <div styleName="spacer" role="separator" className="hidden-mobile" />}
      </InteractivePopup>
    );
  }
}

const mapStateToProps = (state) => ({ viewer: get(state, 'current.viewer') });
export const NavComponent = Nav;
export default connect(mapStateToProps, {})(NavComponent);
